import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { apiRequest } from '@cancercentrum/inca';
import usePromise from '../../hooks/usePromise';
import { AjaxErrorAlert } from '../AjaxErrorAlert';
import { LoadingAlert } from '../LoadingAlert';
import { createIncaFormContext } from './utils';
import { IncaContext } from './IncaContext';
export const IncaContextProviderErrand = (props)=>{
    const { errandId, children, components } = props;
    const { isLoading, error, result, exec } = usePromise();
    const ErrorIndicator = components?.ErrorIndicator || AjaxErrorAlert;
    const LoadingIndicator = components?.LoadingIndicator || LoadingAlert;
    useEffect(()=>{
        exec(async ()=>{
            let patient = undefined;
            const [currentUser, errand, form] = await Promise.all([
                apiRequest('/Users/Current'),
                apiRequest(`/Errands/${errandId}`),
                apiRequest(`/Errands/${errandId}/IncaObject`)
            ]);
            if (errand.document.patientId) {
                patient = await apiRequest(`/Patients/${errand.document.patientId}`);
            }
            return createIncaFormContext({
                currentUser,
                errand,
                patient,
                form
            });
        });
    }, [
        errandId,
        exec
    ]);
    if (error) {
        return /*#__PURE__*/ _jsx(ErrorIndicator, {
            error: error
        });
    }
    if (isLoading || !result) {
        return /*#__PURE__*/ _jsx(LoadingIndicator, {});
    }
    return /*#__PURE__*/ _jsx(IncaContext.Provider, {
        value: result,
        children: children
    });
};
